/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './header/header.component.ngfactory';
import * as i2 from '../../../app/layout/header/header.component';
import * as i3 from '../../../app/common/services/user/user.service';
import * as i4 from '@angular/router';
import * as i5 from '../../../app/layout/layout.component';
const styles_LayoutComponent:any[] = ([] as any[]);
export const RenderType_LayoutComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_LayoutComponent,data:{}});
export function View_LayoutComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),1,'app-header',([] as any[]),(null as any),(null as any),
      (null as any),i1.View_HeaderComponent_0,i1.RenderType_HeaderComponent)),i0.ɵdid(2,
      245760,(null as any),0,i2.HeaderComponent,[i3.UserService],(null as any),(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(4,16777216,(null as any),
          (null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),i0.ɵdid(5,212992,(null as any),
          0,i4.RouterOutlet,[i4.ChildrenOutletContexts,i0.ViewContainerRef,i0.ComponentFactoryResolver,
              [8,(null as any)],i0.ChangeDetectorRef],(null as any),(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    _ck(_v,2,0);
    _ck(_v,5,0);
  },(null as any));
}
export function View_LayoutComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-layout',
      ([] as any[]),(null as any),(null as any),(null as any),View_LayoutComponent_0,
      RenderType_LayoutComponent)),i0.ɵdid(1,49152,(null as any),0,i5.LayoutComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const LayoutComponentNgFactory:i0.ComponentFactory<i5.LayoutComponent> = i0.ɵccf('app-layout',
    i5.LayoutComponent,View_LayoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9hcHAvc3JjL2FwcC9sYXlvdXQvbGF5b3V0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvYXBwL3NyYy9hcHAvbGF5b3V0L2xheW91dC5jb21wb25lbnQudHMiLCJuZzovLy92YXIvYXBwL3NyYy9hcHAvbGF5b3V0L2xheW91dC5jb21wb25lbnQudHMuTGF5b3V0Q29tcG9uZW50Lmh0bWwiLCJuZzovLy92YXIvYXBwL3NyYy9hcHAvbGF5b3V0L2xheW91dC5jb21wb25lbnQudHMuTGF5b3V0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGFwcC1oZWFkZXI+PC9hcHAtaGVhZGVyPlxuICAgIDxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cbiAgIiwiPGFwcC1sYXlvdXQ+PC9hcHAtbGF5b3V0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQSw4Q0FDSTtNQUFBO01BQUEsK0VBQUE7TUFBQTtNQUF5Qiw4Q0FDekI7VUFBQTtVQUFBLG1EQUFBO1VBQUE7Y0FBQTtNQUErQjtJQUQvQjtJQUNBOzs7O29CQ0ZKO01BQUE7Z0NBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/layout/layout.component.ngfactory.ts